module.exports = __webpack_public_path__ + "static/media/fo.32019da0.svg";